import { z } from 'zod';

const HEX = /^#[0-9a-fA-F]{6}$/;
const side = z.enum(['right', 'left']);

export const appearanceSchema = z.object({
  enabled: z.boolean(),
  appearance: z.object({
    shape: z.enum(['round', 'pill']),
    position: side,
    mobilePosition: side,
    /** Empty uses the storefront's own accent colour. */
    primaryColor: z
      .string()
      .trim()
      .refine((v) => v === '' || HEX.test(v), { error: 'chatSettings:validation.hexColor' }),
    headerTitle: z.string().trim().max(80, { error: 'chatSettings:validation.max80' }),
    greetingOnline: z.string().trim().max(300, { error: 'chatSettings:validation.max300' }),
    greetingAway: z.string().trim().max(300, { error: 'chatSettings:validation.max300' }),
    greetingOffline: z.string().trim().max(300, { error: 'chatSettings:validation.max300' }),
    showAgentAvatars: z.boolean(),
    logoMediaId: z.string().nullable(),
    attentionGrabberMediaId: z.string().nullable(),
  }),
});

export type AppearanceForm = z.infer<typeof appearanceSchema>;
